import { StatsigProvider, StatsigUser, useClientAsyncInit } from "@statsig/react-bindings";
import React from "react";
import { useSelector } from "react-redux";

import { BuildFlags } from "../constants";
import { AppState } from "../store";

type Props = {
  children: React.ReactNode;
};

/**
 * Async-initialized Statsig provider for routes that may be accessed without having
 * server-provided bootstrap values (e.g. public/unauth dashboards).
 *
 * This avoids bootstrapping parse errors while still enabling `useFeatureGate` in children.
 */
export const StatsigAsyncProvider: React.FC<Props> = ({ children }) => {
  const { coeffUserEmail, coeffUserId, domain } = useSelector(({ app }: AppState) => ({
    coeffUserEmail: app.coeffUserEmail,
    coeffUserId: app.coeffUserId,
    domain: app.domain,
  }));

  const user: StatsigUser = {
    userID: coeffUserId || undefined,
    email: coeffUserEmail || undefined,
    custom: { domain },
  };

  const { client } = useClientAsyncInit(BuildFlags.statsig_client_key, user, {
    environment: { tier: BuildFlags.statsig_environment },
  });

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};
